import { UserRole } from "../../constants";
import { COACH_ROUTE, DEFAULT_ROUTE, COACH_LIBRARY_ROUTE } from "../../routes/routes";

export const isDrawerItemSelected = (navPath, mode) => {
  const [base, splitValue] =
    mode === UserRole.CLIENT ? [DEFAULT_ROUTE, 0] : [COACH_ROUTE, 1];

  const getBasePath = (path) => path.replace(base, "").split("/")[splitValue];
  const currentBasePath = getBasePath(location.pathname);
  const navBasePath = getBasePath(navPath);
  
  if (mode === UserRole.COACH) {
    const isOnLibraryRoute = location.pathname.includes('/library/');
    const isLibraryNavItem = navPath.includes(COACH_LIBRARY_ROUTE);
    const isProgramsNavItem = navPath.includes('/programs') && !navPath.includes('/library');
    
    if (isOnLibraryRoute && isLibraryNavItem) {
      return true;
    }

    if (isOnLibraryRoute && isProgramsNavItem) {
      return false;
    }
  }
  
  return currentBasePath === navBasePath;
};
